
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 348 263","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.562 63.03l143.569 182.584c12.577 22.044 32.968 22.044 45.551 0L340.27 63.005c2.804-3.996 5.825-11.119 6.437-15.967C348.678 31.347 350.238 0 331.211 0H16.608C-2.42 0-.852 31.365 1.124 47.062c.612 4.841 3.635 11.971 6.438 15.968z","fill":"#000"}})])
          )
        }
      }
    